





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Card } from 'element-ui';
import { MilestoneFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-card': Card
  }
})
export default class MarineTrafficMap extends Vue {
  @Prop({ type: Object }) trackableMilestone?: MilestoneFields;
  // height in pixels
  @Prop({ type: String, default: '600px' }) height!: string;
  // width in pixels or percentage
  @Prop({ type: String, default: '100%' }) width!: string;

  private link: string | null = null
  private linkSegments: string[] = [
    'https://www.vesselfinder.com/aismap?zoom=5',
    'lat=undefined',
    'lon=undefined',
    'width=100',
    'height=100',
    'names=true',
    `imo=${this.vesselImo}`,
    'track=true',
    'fleet=false',
    'fleet_name=false',
    'fleet_hide_old_positions=false',
    'clicktoact=undefined',
    'store_pos=undefined',
    'ra=+rh'
  ]

  mounted() {
    this.link = this.linkSegments.join('&');
  }

  private isDone(milestone: MilestoneFields, eventKey: string): boolean {
    if (milestone?.doneDates) {
      return !!milestone.doneDates.find(date => {
        return date.eventName === eventKey && date.doneAt;
      });
    }
    // if no trackableMilestone, will return false
    return false;
  }

  get vesselImo() {
    return this.trackableMilestone?.vessel?.imo || null;
  }
}
